{"PT_VERSION":"20260723111106-87865e64"}